import messagesFr from './locales/fr'
import messagesEn from './locales/en'
import messagesDe from './locales/de'
import messagesEs from './locales/es'
import messagesIt from './locales/it'
import messagesPl from './locales/pl'
import { flatten } from 'flat'

export const fr = flatten(messagesFr)
export const en = flatten(messagesEn)
export const de = flatten(messagesDe)
export const es = flatten(messagesEs)
export const it = flatten(messagesIt)
export const pl = flatten(messagesPl)



// WEBPACK FOOTER //
// ./src/messages.js